import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import cx from "classnames";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input as RInput,
  UncontrolledTooltip,
} from "reactstrap";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { Input } from "../../ui/input";
import Progressbar from "../../ui/progressbar";
import { useDispatch, useSelector } from "react-redux";
import { uploadItineraryAsset } from "../../../store/actions/documentActions";
import Modal from "../../ui/modal";
import DeleteElemModal from "../Modals/DeleteElemModal";
import useDragAndDrop from "../../../hooks/useDragAndDropV2";
import { PORTFOLIO } from "../../../constants/editor";
import useAlignment from "../../../hooks/useAlignment";
import useAddWidget from "../../../hooks/useAddWidget";
import useElementInnerHtml from "../../../hooks/useElementInnerHtml";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { widgetConfig } from "../editor_config";
import { hexToRGB } from "../../../_helpers/utils";

let style = Object.assign({}, global);

const WorkItems = props => {
  const dropdownRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Toggle the dropdown
  const toggle = () => {
    if (props.showForm) props.setshowForm(false);
    setIsOpen(prevState => !prevState);
  };

  const dropdownContainer = document.querySelector(".itinerary-modal");

  const editItemInfo = () => {
    props.setFormIndex(props.workItemIdx);
    props.setshowForm(true);
  };

  const deleteHandler = () => {
    const newArray = props.formsList.filter((_, index) => index !== props.workItemIdx);
    props.setFormsList(newArray);
  };

  const toggleModal = () => {
    setShowModal(prevState => !prevState);
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const currentDropdown = document.querySelectorAll(".custom-itinerary-dropdown.show")[0];
        if (currentDropdown) {
          // Check if menu has placed top of the dropdown and container present
          if (dropdownRef?.current && dropdownRef.current?.menuRef?.current && dropdownContainer) {
            const parentDropdown = dropdownRef.current.containerRef.current;
            const menuElement = dropdownRef.current.menuRef.current;

            const parentDropdownStyle = parentDropdown.getBoundingClientRect();
            const menuElementStyle = menuElement.getBoundingClientRect();
            if (menuElementStyle?.top < parentDropdownStyle?.top) {
              let calculatedTop = parentDropdownStyle.top + parentDropdownStyle.height + 2;

              menuElement.style.transform = `translate3d(${menuElementStyle.left}px, ${calculatedTop}px, 0px)`;
              menuElement.style.opacity = 1;
            }
            menuElement.style.opacity = 1;
          }
        }
      }, 15);
    }
  }, [isOpen]);

  return (
    <div className={style["trip-list-item"]}>
      <Icon icon="ui-drag2" additionalclass={"drag-icon"} />
      <ul>
        <li className={cx(style["trip-icon"], style["mr-3"])}>
          <Icon icon={`ui-portfolio`} />
        </li>
        <li className={cx(style["trip-title"], style["mr-3"], style["flex-grow-1"])}>
          <div className={style["text-truncate"]}>{props.itemInfo?.title}</div>
        </li>
        <li className={cx(style["trip-images"], style["mr-3"])}>
          <ul className="p-0">
            <li>
              <img src={props.itemInfo?.image} className={style["img-fluid"]} />
            </li>
          </ul>
        </li>
        <li className={style["more-action"]}>
          <Dropdown ref={dropdownRef} toggle={toggle} isOpen={isOpen}>
            <DropdownToggle tag="a" className={cx(style["dropdown-toggle"])}>
              <Icon icon="ui-more" id={`more-tooltip-${props.workItemIdx}`} />
              <UncontrolledTooltip
                placement="top"
                target={`more-tooltip-${props.workItemIdx}`}
                trigger="hover"
                boundariesElement={dropdownContainer}>
                More
              </UncontrolledTooltip>
            </DropdownToggle>
            <DropdownMenu
              right
              className={cx(style["shadow"], style["border-0"], style["rounded-sm"], "custom-itinerary-dropdown")}
              container={dropdownContainer ? dropdownContainer : undefined}
              style={dropdownContainer && { opacity: 0 }}>
              <DropdownItem tag="a" className={style["font-14"]} onClick={editItemInfo}>
                <div className={cx(style["d-flex"], style["align-items-center"])}>
                  <Icon icon="ui-edit" additionalclass={"mr-2"} />
                  <span>Edit</span>
                </div>
              </DropdownItem>
              <DropdownItem tag="a" className={style["font-14"]}>
                <div className={cx(style["d-flex"], style["align-items-center"])} onClick={() => setShowModal(true)}>
                  <Icon icon="ui-trash" additionalclass={"mr-2"} />
                  <span>Delete</span>
                </div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
      </ul>
      {showModal && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          component={DeleteElemModal}
          modalTitle={"Delete"}
          modalBody={"Are you sure to delete the work? This action can’t be reversed."}
          modalButtonLabel={"Delete"}
          deleteElem={deleteHandler}
          closeModal={toggleModal}
          backdrop={false}
          contentClassName={"shadow"}
        />
      )}
    </div>
  );
};
WorkItems.propTypes = {
  formsList: PropTypes.obj,
  setFormsList: PropTypes.func,
  workItemIdx: PropTypes.number,
  itemInfo: PropTypes.obj,
  showForm: PropTypes.bool,
  setshowForm: PropTypes.func,
  setFormIndex: PropTypes.func,
};

const AssetLoader = ({ assetId }) => {
  const [uploadProgress, setUploadProgress] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const intervalRef = useRef(null);

  const calculateProgress = val => {
    let progress = val ?? 0;
    let maxProgress = 95;
    intervalRef.current = setInterval(() => {
      if (progress < maxProgress) {
        progress += 3;
        if (progress > maxProgress) {
          progress = maxProgress;
        }
      }
      setUploadProgress(progress);
      if (progress >= maxProgress) {
        clearInterval(intervalRef.current);
      }
    }, 400);
  };

  useEffect(() => {
    calculateProgress();
  }, []);

  useEffect(() => {
    if (!assetId) setShowLoader(true);
    else if (showLoader) {
      clearInterval(intervalRef.current);
      setUploadProgress(100);
      setTimeout(() => setShowLoader(false), 1000);
    }
  }, [assetId]);

  return (
    <>
      {showLoader && (
        <div className={style["loading"]}>
          <div
            className={cx(
              style["progress"],
              style["download-progressbar"],
              style["my-4"],
              style["m-auto"],
              style["w-75"]
            )}>
            <Progressbar progressbarInfo={uploadProgress} />
          </div>
        </div>
      )}
    </>
  );
};
AssetLoader.propTypes = {
  assetId: PropTypes.string,
};

const ProgressLoader = props => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(true);
  const intervalRef = useRef(null);

  const calculateProgress = val => {
    let progress = val ?? 0;
    let maxProgress = 95;
    intervalRef.current = setInterval(() => {
      if (progress < maxProgress) {
        progress += 3;
        if (progress > maxProgress) {
          progress = maxProgress;
        }
      }
      setUploadProgress(progress);
      if (progress >= maxProgress) {
        clearInterval(intervalRef.current);
      }
    }, 400);
  };

  useEffect(() => {
    calculateProgress();
  }, []);

  useEffect(() => {
    if (props.assetId) {
      clearInterval(intervalRef.current);
      setUploadProgress(100);
      setTimeout(() => setShowLoader(false), 1000);
    }
  }, [props.assetId]);

  return <>{showLoader && <Progressbar progressbarInfo={uploadProgress} />}</>;
};
ProgressLoader.propTypes = {
  assetId: PropTypes.string,
};

const FormSection = props => {
  const { id: documentId } = useParams();
  const dispatch = useDispatch();

  const [formFields, setFormFields] = useState();
  const [tagError, setTagError] = useState("");
  const [uploadAssetError, setUploadAssetError] = useState();
  const [isUploadDone, setIsUploadDone] = useState();
  const [disableInsert, setDisableInsert] = useState(true);

  const handleChange = (type, value) => {
    const updatedForm = {
      ...formFields,
      [type]: value,
    };

    setFormFields(updatedForm);

    // 🔹 Link section validation
    let linkValidation = true;

    if (updatedForm.link) {
      const urlValid = updatedForm.url.trim() !== "" && isValidURL(updatedForm.url.trim());
      const labelValid = updatedForm.linkLabel.trim() !== "";
      linkValidation = urlValid && labelValid;
    }

    // 🔹 Tag validation
    let tagsValid = true;

    if (updatedForm.tags.length > 3) {
      setTagError("Maximum 3 tags allowed.");
      tagsValid = false;
    } else if (updatedForm.tags.some(tag => tag.trim() === "" || tag.trim().length > 20)) {
      setTagError("Each tag must be between 1 and 20 characters.");
      tagsValid = false;
    } else {
      setTagError(""); // clear error
    }

    // 🔹 Final validation
    const isValid =
      updatedForm.title.trim() !== "" &&
      updatedForm.description.trim() !== "" &&
      updatedForm.image.trim() !== "" &&
      linkValidation &&
      tagsValid;

    setDisableInsert(!isValid);
  };

  const isValidURL = url => {
    const pattern = /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
    return pattern.test(url);
  };

  const fileSelectedHandler = e => {
    const file = e.target.files[0];

    let fileSize = file.size / 1e6;
    let fileFormat = file.type.split("/");
    let allowedImageTypes = ["jpeg", "jpg", "png", "webp"];
    let maxImageSize = 5; // in MB

    // upload image
    if (file && allowedImageTypes.includes(fileFormat[1]?.toLowerCase()) && fileSize <= maxImageSize) {
      setUploadAssetError({ status: false, message: "success" });
      setIsUploadDone(false);
      uploadImage(file);
    }
    // if file is large that max size
    else if (fileSize > maxImageSize) {
      e.target.value = ""; // cleaning the file upload field
      setUploadAssetError({
        status: true,
        message: `File Size should be maximum ${maxImageSize} MB.`,
      });
    }
    // if invalid format
    else {
      e.target.value = ""; // cleaning the file upload field
      setUploadAssetError({ status: true, message: "Invalid Format!!" });
    }

    setTimeout(function () {
      setUploadAssetError({ status: false, message: "" });
    }, 3000);
  };

  const uploadImage = file => {
    let formData = new FormData();
    formData.append("files", file);

    dispatch(uploadItineraryAsset(documentId, props.companyCluster, formData, "portfolio")).then(resp => {
      setIsUploadDone(true);
      handleChange("image", resp?.result?.file_urls[0][0]);
    });
  };

  const saveWorkInfo = () => {
    // UPDATE existing form
    if (props.formIndex !== undefined) {
      const updatedList = [...props.formsList];
      updatedList[props.formIndex] = formFields;
      props.setFormsList(updatedList);
    }
    // ADD new form
    else {
      props.setFormsList(prev => [...prev, formFields]);
    }

    // Reset form after save
    setFormFields({
      title: "",
      description: "",
      tags: [],
      image: "",
      link: false,
      url: "",
      linkLabel: "",
    });

    setDisableInsert(true);
    props.setshowForm(false);
    props.setFormIndex();
  };

  useEffect(() => {
    //set default blank value : Add Form
    if (props.formIndex === undefined) {
      setFormFields({
        title: "",
        description: "",
        tags: [],
        image: "",
        link: false,
        url: "",
        linkLabel: "",
      });
    }
    //set exsisting value : Update Form
    else {
      setFormFields({ ...props.formsList[props.formIndex] });
    }
  }, []);

  return (
    <div className={cx(style["form-section"])}>
      <h5 className={cx(style["fw-7"])}>
        <span className={style["icon-box"]}>
          <Icon icon={`ui-portfolio`} />
        </span>
        {props.formIndex !== undefined ? "Update" : "Add"} Work
      </h5>

      {formFields && (
        <div className={cx(style["customScroll"], style["scroll-Y"])}>
          <form className={cx(style["form-area"])}>
            {/* Title */}
            <div className={style["mb-2"]}>
              <Input
                type="text"
                label="Title"
                required={true}
                placeholder={"Example: Logo design for a SaaS brand"}
                title=""
                multilineClass="m-0"
                maxLength={45}
                value={formFields.title}
                onChange={e => handleChange("title", e.target.value)}
              />
              <div className={cx(style["d-flex"], style["justify-content-end"])}>{`${formFields.title.length}/45`}</div>
            </div>

            {/* Description */}
            <div className={style["mb-2"]}>
              <Input
                type="multiline"
                label="Description"
                required={true}
                placeholder={"Briefly describe what you created and the goal of this work."}
                multilineClass="m-0"
                title=""
                maxLength={140}
                value={formFields.description}
                onChange={e => handleChange("description", e.target.value)}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              />
              <div
                className={cx(
                  style["d-flex"],
                  style["justify-content-end"]
                )}>{`${formFields.description.length}/140`}</div>
            </div>

            {/* Tags */}
            <div className={style["tag-area"]}>
              <div className={cx(style["custom-tooltip"])}>
                <Icon icon="information" additionalclass={"font-12"} />
                <span className={cx(style["custom-tooltip-content"], style["bottom"], style["mt-3"])}>
                  Max 20 characters per tag
                </span>
              </div>
              <Input
                returnType="formGroup"
                type="tag"
                label="Tags"
                placeholder={"Add up to 3 tags (Press Enter to add each tag)"}
                defaultValue={formFields.tags}
                updateState={value => handleChange("tags", value)}
              />
              {tagError && (
                <div className={cx(style["alert"], style["alert-block"], style["alert-danger"])}>{tagError}</div>
              )}
            </div>

            {/* Cover Image */}
            <div className={cx(style["form-group"])}>
              <label className={cx(style["title-border"], style["required-mark"])}>
                <div className={cx(style["d-flex"], style["align-items-center"])}>
                  Cover Image
                  <div className={cx(style["custom-tooltip"], style["pl-2"])}>
                    <Icon icon="information" additionalclass={"font-12"} />
                    <span
                      className={cx(style["custom-tooltip-content"], style["bottom"], style["mt-3"], style["ml-1"])}>
                      JPG, PNG, WebP. Max 5 MB
                    </span>
                  </div>
                </div>
              </label>
              <div className={cx(style["d-flex"], style["align-items-center"])}>
                {/* image upload section */}
                <div className={style["image-container-list"]}>
                  <div className={cx(style["asset-palette"], style["mb-4"])}>
                    <div className={cx(style["asset-palette-list"])}>
                      {(formFields.image || isUploadDone === false) && (
                        <div className={cx(style["asset-container"])}>
                          {/* Delete icon */}
                          <div className={style["delete-img"]} onClick={() => handleChange("image", "")}>
                            <Icon icon="ui-trash" />
                          </div>

                          {/* image */}
                          {formFields.image && (
                            <div className={cx(style["asset-thumb"])}>
                              <img src={formFields.image}></img>
                            </div>
                          )}

                          {/* Upload image Progressbar */}
                          {isUploadDone === false && <AssetLoader assetId={isUploadDone} />}
                        </div>
                      )}

                      {/* image upload */}
                      {!formFields.image && (isUploadDone || isUploadDone === undefined) && (
                        <div className={cx(style["fileUpload"])}>
                          <div className={cx(style["asset-box"], style["add-new"])}>
                            <Icon icon="ui-plus" />
                          </div>
                          <input
                            required={true}
                            type="file"
                            accept={"image/jpeg, image/png, image/webp"}
                            onChange={e => fileSelectedHandler(e)}
                            title=""
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* image upload section left */}
                <div className={style["ml-4"]}>
                  <p>
                    <span className="fw-7">Orientation</span> <br></br> For best results,{" "}
                    <span className="fw-7">use a square image</span>
                  </p>

                  {/* Error messege area */}
                  {uploadAssetError?.status && (
                    <div
                      id="uploadedImageErrorBox"
                      className={cx(style["alert"], style["alert-block"], style["alert-danger"])}>
                      {uploadAssetError.message}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Link */}
            <div className={cx(style["custom-control"], style["custom-switch"], style["mb-2"])}>
              <RInput
                type="checkbox"
                className={style["custom-control-input"]}
                defaultChecked={formFields.link}
                id="customSwitchForLink"
                value={formFields.link}
                onClick={() => handleChange("link", !formFields.link)}
              />

              <label className={style["custom-control-label"]} htmlFor="customSwitchForLink">
                Add Link
              </label>
            </div>

            {formFields.link && (
              <>
                {/* Link URL */}
                <div className={style["mb-2"]}>
                  <Input
                    type="text"
                    label="URL"
                    required={true}
                    placeholder={"https://www.example.com"}
                    title=""
                    value={formFields.url}
                    onChange={e => handleChange("url", e.target.value)}
                  />
                </div>

                {/* Link Label */}
                <div className={style["mb-2"]}>
                  <Input
                    type="text"
                    label="Link Label"
                    required={true}
                    placeholder={"Example: View Project"}
                    multilineClass="m-0"
                    title=""
                    maxLength={15}
                    value={formFields.linkLabel}
                    onChange={e => handleChange("linkLabel", e.target.value)}
                  />
                  <div
                    className={cx(
                      style["d-flex"],
                      style["justify-content-end"]
                    )}>{`${formFields.linkLabel.length}/15`}</div>
                </div>
              </>
            )}
          </form>
        </div>
      )}

      <div className={style["left-pane-footer"]}>
        <button
          type="button"
          onClick={saveWorkInfo}
          className={cx(style["btn"], style["btn-primary"])}
          disabled={disableInsert}>
          {props.formIndex !== undefined ? "Update" : "Save"}
        </button>
        <button
          type="button"
          className={cx(style["btn"], style["btn-border"])}
          onClick={() => {
            props.setshowForm(false);
            props.setFormIndex();
          }}>
          Cancel
        </button>
      </div>
    </div>
  );
};
FormSection.propTypes = {
  formsList: PropTypes.obj,
  setFormsList: PropTypes.func,
  formIndex: PropTypes.number,
  setFormIndex: PropTypes.func,
  setshowForm: PropTypes.func,
  companyCluster: PropTypes.string,
};

const CanvasHtmlData = ({ canvasConfigData }) => {
  const tagStyle = {};
  if (canvasConfigData?.tagColor) {
    tagStyle.backgroundColor = hexToRGB(canvasConfigData.tagColor);
  }
  if (canvasConfigData?.tagContentColor) {
    tagStyle.color = hexToRGB(canvasConfigData.tagContentColor);
  }

  const frameStyle = {};
  if (canvasConfigData?.frameColor) {
    frameStyle.backgroundColor = hexToRGB(canvasConfigData.frameColor);
  }

  const sectionBodyStyle = {};
  if (canvasConfigData?.sectionBodyColor) {
    sectionBodyStyle.backgroundColor = hexToRGB(canvasConfigData.sectionBodyColor);
  }

  const sectionBodyContentColor = {};
  if (canvasConfigData?.sectionBodyContentColor) {
    sectionBodyContentColor.color = hexToRGB(canvasConfigData.sectionBodyContentColor);
  }

  const BorderColor = {};
  if (canvasConfigData?.sectionBorderColor) {
    BorderColor.border = `1px solid ${hexToRGB(canvasConfigData.sectionBorderColor)}`;
  }

  return (
    <div
      className={cx(style["w-100"], style["pricingTable_editor"], style["portfolio_editor"])}
      style={canvasConfigData?.["font-family"] ? { fontFamily: canvasConfigData["font-family"] } : {}}>
      {canvasConfigData.items.map((item, itemIndex) => (
        <div className={cx(style["mb-3"], style["card"], style["rounded-md"])} key={itemIndex} style={BorderColor}>
          <div className={cx(style["row"], style["no-gutters"])}>
            <div className={cx(style["col-md-4"], style["p-4"], style["left"])} style={frameStyle}>
              <div className="img-wrap">
                <img src={item.image} alt="" className={cx(style["img-fluid"], style["rounded-md"])} />
              </div>
            </div>
            <div className={cx(style["col-md-8"], style["right"], "section-body")} style={sectionBodyStyle}>
              <div className={cx(style["card-body"])}>
                <h5 className={cx(style["card-title"], style["fw-7"])} style={sectionBodyContentColor}>
                  {item.title}
                </h5>
                <p className={cx(style["card-text"])} style={sectionBodyContentColor}>
                  {item.description}
                </p>

                {/* Tag area */}
                {item.tags.length > 0 && (
                  <ul className={cx(style["tags"], style["mb-3"])}>
                    {item.tags.map((tag, tagIdx) => (
                      <li key={tagIdx} style={tagStyle}>
                        {tag}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Link area */}
                {item.link && (
                  <a className={cx(style["btn"], style["btn-border"], style["icon-box"])} data-url={item.url}>
                    <Icon icon="ui-external-link" additionalclass={""} />
                    {item.linkLabel}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const Portfolio = ({ closeModal, modalFullScreen, setModalFullScreen, editTable }) => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  const htmlMode = false;

  const [insertHtmlMode, setInsertHtmlMode] = useState(false);
  const [insertedHtmlData, setInsertedHtmlData] = useState([]);
  const [showForm, setshowForm] = useState();
  const [formsList, setFormsList] = useState([]); // 👈 array of objects
  const [formIndex, setFormIndex] = useState();
  const [readyToUpdate, setReadyToUpdate] = useState(false);
  const [addWidgetClicked, setAddWidgetClicked] = useState(false);
  const [dataparam, setDataParam] = useState();
  const [assetInnerContent, setAssetInnerContent] = useState();
  const [widgetWidth, setWidgetWidth] = useState();
  const [widgetHeight, setWidgetHeight] = useState();
  const [customCss, setCustomCss] = useState(false);

  const { items: workList, containerProps, getItemProps } = useDragAndDrop(formsList, "vertical", setReadyToUpdate);
  const { postion: getPosition } = useAlignment(addWidgetClicked, widgetWidth, widgetHeight, "middle-center");
  const getNewWidgetObject = useAddWidget(
    addWidgetClicked,
    PORTFOLIO,
    dataparam,
    getPosition,
    widgetWidth,
    widgetHeight
  );
  useElementInnerHtml(
    addWidgetClicked,
    setAddWidgetClicked,
    PORTFOLIO,
    assetInnerContent,
    dataparam,
    getNewWidgetObject,
    customCss
  );

  const companyInfo = useSelector(state => state?.auth?.company);

  const setFullScreen = () => {
    setModalFullScreen(!modalFullScreen);
  };

  const close = () => {
    closeModal && closeModal();
    if (modalFullScreen) setModalFullScreen(false);
  };

  const insertTable = () => {
    let insertedTableData = editTable ? { ...editTable, items: formsList } : { items: formsList };
    setInsertedHtmlData({ ...insertedTableData });

    if (htmlMode) setInsertHtmlMode(true);

    // Use this htmlString for insert
    if (!editTable) {
      const htmlString = ReactDOMServer.renderToString(<CanvasHtmlData canvasConfigData={insertedTableData} />);
      const elem = document.createElement("div");
      elem.innerHTML = htmlString;
      // setLatestLookupIds(filterSections(dragItems));
      // add pheudo elem in editor
      const parent = document.getElementById(metadata.activeBlockId);
      const pheudoElem = document.createElement("div");
      pheudoElem.id = "pheudoElem";
      pheudoElem.style.width = "700px";
      pheudoElem.innerHTML = htmlString;
      parent.appendChild(pheudoElem);

      // insert into editor
      setTimeout(() => {
        const jsonString = JSON.stringify(insertedTableData);
        let paramObj = { "data-table-config": jsonString };
        let dataAttr = { ...widgetConfig[PORTFOLIO].dataAttr, ...paramObj };
        let offsetHeight = document.querySelector("#pheudoElem .portfolio_editor")?.offsetHeight;
        let offsetWidth = 700;
        let scale = 1242 / offsetWidth; // 1242 is page width(which is static)
        document.querySelector("#pheudoElem").remove();
        setCustomCss({
          transform: `scale(${scale})`,
          width: `${offsetWidth}px`,
          height: `${offsetHeight}px`,
        }); // set width height to inner div
        setWidgetWidth(offsetWidth * scale); // set width  to main div
        setWidgetHeight(offsetHeight * scale); // set height to main div
        setAssetInnerContent(elem);
        setDataParam(dataAttr);
        setAddWidgetClicked(true);
      }, 100);
    }
    // update
    else {
      const jsonString = JSON.stringify(insertedTableData);
      const htmlString = ReactDOMServer.renderToString(<CanvasHtmlData canvasConfigData={insertedTableData} />);

      const elem = document.createElement("div");
      elem.innerHTML = htmlString;
      document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).innerHTML = elem.innerHTML;
      // add pheudo elem in editor
      const parent = document.getElementById(metadata.activeBlockId);
      const pheudoElem = document.createElement("div");
      pheudoElem.id = "pheudoElem";
      pheudoElem.style.width = document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.width;
      pheudoElem.innerHTML = htmlString;
      parent.appendChild(pheudoElem);
      setTimeout(() => {
        let offsetHeight = document.querySelector("#pheudoElem .portfolio_editor")?.offsetHeight;
        let offsetWidth = parseFloat(
          document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.width
        );
        let scale = parseFloat(
          document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.transform.split("(")[1]
        );
        document.querySelector("#pheudoElem").remove();
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.width = `${offsetWidth}px`;
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.height = `${offsetHeight}px`;
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).style.transform = `scale(${scale})`;
        const targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);
        let newArray = Object.assign([...widgets]);
        newArray = Object.assign([...newArray], {
          [targetWidgetIndex]: {
            ...newArray[targetWidgetIndex],
            data: {
              ...newArray[targetWidgetIndex].data,
              "data-table-config": jsonString,
            },
            style: {
              ...newArray[targetWidgetIndex].style,
              width: `${offsetWidth * scale}px`,
              height: `${offsetHeight * scale}px`,
            },
            innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
          },
        });
        updateWidgets(newArray);
      }, 200);
      setTimeout(() => {
        close();
      }, 210);
    }
  };

  //Close modal after innserted to canvas
  useEffect(() => {
    if (getNewWidgetObject?.id && !htmlMode) {
      close();
    }
  }, [getNewWidgetObject]);

  useEffect(() => {
    setFormsList(workList);
  }, [workList]);

  // when re-arrange work list close the form section that user can not update
  useEffect(() => {
    if (readyToUpdate && showForm) {
      setshowForm(false);
    }
  }, [readyToUpdate]);

  useEffect(() => {
    if (editTable) {
      setFormsList(editTable.items);
    }
  }, []);

  return (
    <>
      {!insertHtmlMode && (
        <div className={style["table-modal-wrap"]}>
          {/* Modal header section */}
          <div className="d-flex justify-content-between modal-header">
            <h4 className={cx(style["fw-7"], style["mb-0"])}>Portfolio</h4>
            <div className={style["header-center"]}>{/* <FlashMessage flashMessage={customMsg} /> */}</div>
            <ul className={style["d-flex"]}>
              <li className={cx(style["expand-btn"], style["rounded"])} onClick={setFullScreen}>
                <Icon icon={modalFullScreen ? "ui-collapse" : "ui-expand"} />
              </li>
              <li className={cx(style["cross-modal"], style["rounded"])} onClick={close}>
                <Icon icon="ui-close" />
              </li>
            </ul>
          </div>

          <div className={cx(style["modal-body"], style["row"], style["p-0"], style["m-0"])}>
            {/* modal left section and form section */}
            <div className={cx(style["left-pane"])}>
              {/* Add Work Icon */}
              {!showForm && (
                <div
                  className={cx(
                    style["w-100"],
                    style["h-100"],
                    style["d-flex"],
                    style["flex-column"],
                    style["align-items-center"],
                    style["justify-content-center"]
                  )}>
                  <div
                    key={0}
                    className={cx(style["add-work"], {
                      [style["disable"]]: formsList?.length === 6,
                    })}
                    onClick={() => {
                      if (formsList?.length >= 6) return;
                      else {
                        setFormIndex();
                        setshowForm(true);
                      }
                    }}>
                    <a>
                      <Icon icon={`ui-plus`} />
                      <span className={style["item-text"]}>Add Work</span>
                    </a>
                  </div>
                  <p>
                    You can add <span className="fw-7">up to 6</span> work samples
                  </p>
                </div>
              )}

              {/* Add work Form */}
              {showForm && (
                <FormSection
                  formsList={formsList}
                  setFormsList={setFormsList}
                  formIndex={formIndex}
                  setFormIndex={setFormIndex}
                  setshowForm={setshowForm}
                  companyCluster={companyInfo?.cluster_code}
                />
              )}
            </div>

            {/* modal right section  */}
            <div
              className={cx(style["right-pane"], style["col"], style["d-flex"], style["flex-grow-1"], {
                [style["default-itinerary"]]: formsList?.length < 1,
                [style["record-itinerary"]]: formsList?.length > 0,
              })}>
              <Card className={cx(style["w-100"])}>
                <CardHeader className={cx(style["d-flex"], style["align-items-center"])}>
                  <h5 className={cx(style["mb-0"], style["fw-7"], style["edit-title"], style["d-flex"])}>Portfolio</h5>
                </CardHeader>

                <CardBody className={style["p-0"]}>
                  {/* Defauls empty list message */}
                  {formsList?.length < 1 && (
                    <div className={cx(style["defalt"])}>
                      <div className={cx(style["defalt-info"])}>
                        <span className={style["icon-box"]}>
                          <Icon icon="ui-idea" />
                        </span>
                        <p className="fw-7">How it works</p>
                        <p>
                          Click Add Work in the left pane to begin. Upload a cover image, add a title and description,
                          and include up to three tags for context. Optionally, add a link to the live project or full
                          work.
                        </p>
                        <p>
                          Ready? Click <span className="fw-7">Add Work </span> to get started.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* work list */}
                  {formsList?.length > 0 && (
                    <div className={style["trip-details"]}>
                      <div className={style["trip-lable"]}>
                        <ul className={cx(style["d-flex"], style["align-items-center"])}>
                          <li></li>
                          <li className={cx(style["trip-lable-title"], style["flex-grow-1"], style["mr-3"])}>Title</li>
                          <li className={style["trip-lable-image"]}>Cover Image</li>
                          <li></li>
                        </ul>
                      </div>

                      <div
                        className={cx(style["trip-list"], style["customScroll"], style["scroll-Y"])}
                        {...containerProps}>
                        {formsList?.map((itemInfo, itemIdx) => (
                          <div key={itemIdx} {...getItemProps(itemIdx)}>
                            <WorkItems
                              formsList={formsList}
                              setFormsList={setFormsList}
                              workItemIdx={itemIdx}
                              itemInfo={itemInfo}
                              showForm={showForm}
                              setshowForm={setshowForm}
                              setFormIndex={setFormIndex}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>

              {formsList?.length > 0 && (
                <div className={cx(style["right-pane-footer"])}>
                  <button
                    type="button"
                    onClick={insertTable}
                    className={cx(style["btn"], style["btn-primary"])}
                    disabled={showForm}>
                    {!editTable ? "Insert" : "Update"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* below section need to delete after insert html page design done */}
      {insertHtmlMode && (
        <Modal
          size="lg"
          showModal={insertHtmlMode}
          component={CanvasHtmlData}
          canvasConfigData={insertedHtmlData}
          setShowModal={setInsertHtmlMode}
        />
      )}
    </>
  );
};

export default Portfolio;
